/*
  h26-byo.js: "Build your own set" on the LP taste section (Amir + Seb, Oct 20; mockup v2 approved,
  then Amir's preview feedback Oct 20: steady prices that show the saving, "Add to cart" as the button,
  no sticky tray, one helper they can close or use to open the cart).
  Loaded only by sections/h26-lp-taste.liquid when its byo_on setting is on.

  The cart IS the set: "Add to cart" adds the bottle through the card's own form[data-h26-atc]
  (h26-atc.js: _source h26-lp-byo, same-line reuse, sold-out handling), with data-h26-no-open so
  UpCart refreshes without opening. The cards and the helper read /cart.js, so the tier shown always
  counts what Shopify's discount counts: one-time lines of the eligible variants (the 7 everyday
  oils; the 3 early oils, sets and subscriptions don't count). Discounts themselves are Shopify
  automatic discounts on the collection byo-everyday-oils-2026 (2 = 3%, 3 = 15%, 4 = 21%, 5+ = 24%);
  the numbers here are display only and come from the section (data-byo-cfg).
  Free shipping: only where the market's Ship window record has a threshold, checked in money (see checkFree).

  Card price block (two fixed lines, so nothing jumps): [data-byo-pnow] price, [data-byo-pwas] old price
  (struck, shown once the bottle's set discount applies), [data-byo-psave] "Save $x" per bottle.
  Helper [data-byo-toast]: a light popover that floats from the card just added (above its button, arrow on
  it), and stays until closed ([data-byo-close], Escape, a tap elsewhere) or the cart is opened ([data-byo-view]).
  A customer's code (Oct 20, e.g. ONEOFUS): Shopify keeps whichever saves more, never both on a bottle. When the code
  wins, the cards show Shopify's real line prices and the helper says "Your code is on · ONEOFUS saves you $x" plus
  the first tier that would beat the code (Amir: "fix the builder gap").
  Helper buttons (Amir Oct 20): View cart, and Add more (closes it, slides the row to the next bottle not
  in the cart and pulses its Add to cart).
  Events (window.OOH26.track): byo_toast_view, byo_view_cart, byo_add_more, byo_toast_close, byo_remove. Adds are atc_result (h26-atc).
*/
(function () {
  'use strict';
  function boot(sec) {
    if (!sec || sec.__byo) return; sec.__byo = true;
    var C; try { C = JSON.parse(sec.getAttribute('data-byo-cfg')); } catch (e) { return; }
    // fallbacks: a page cached from before a release can carry an older config than this script (seen Oct 20)
    var D = { built: 'You built your own set!', line: '{n} bottles · {p}% off · you save {amt}', codeHead: 'Your code is on',
      codeLine: '{code} saves you {amt}', codeNext: 'Add {k} more for {p}% off, more than your code.', yourCode: 'Your code' };
    C.txt = C.txt || {}; for (var dk in D) if (!C.txt[dk]) C.txt[dk] = D[dk];
    var cards = [].slice.call(sec.querySelectorAll('[data-byo-card]'));
    var elig = {}; cards.forEach(function (c) { elig[c.getAttribute('data-vid')] = true; });
    var toastEl = sec.querySelector('[data-byo-toast]');
    var state = { qty: {}, n: 0, lines: [], full: 0 };
    // free shipping: the market's threshold in the visitor's money (Liquid, exact case) or converted in the
    // browser (h26-threshold.js, convert case). freeN ("3 bottles ship free") stays only if the cheapest
    // freeN eligible bottles at their tier really reach it; else every free-shipping word goes.
    var freeCents = +C.freeCents || 0, freeN = +C.freeN || 0;

    function track(n, d) { try { if (window.OOH26 && window.OOH26.track) window.OOH26.track(n, d || {}, sec); } catch (e) {} }
    function pct(n) { var p = 0; C.tiers.forEach(function (t) { if (n >= t[0]) p = t[1]; }); return p; }
    function next(n) { for (var i = 0; i < C.tiers.length; i++) if (C.tiers[i][0] > n) return C.tiers[i]; return null; }
    // money in the visitor's currency, shaped like the Liquid sample of 1234.56
    function money(cents) {
      var s = C.sample || '', v = (Math.round(cents) / 100);
      var euro = /1\.234,56/.test(s), neg = v < 0; v = Math.abs(v);
      var parts = v.toFixed(2).split('.'), int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, euro ? '.' : ',');
      var num = euro ? int + ',' + parts[1] : int + '.' + parts[1];
      var out = s ? s.replace(euro ? '1.234,56' : '1,234.56', num) : num;
      return (neg ? '-' : '') + out;
    }
    // Shopify takes the % off each bottle and rounds DOWN to the cent (checked Oct 20 with draftOrderCalculate on 2 to 7
    // bottles: 3 bottles save $22.66, not $22.69). The page does the same, so page and checkout match to the cent.
    function off1(price, p) { return p ? Math.floor(price * p / 100 + 1e-9) : 0; }
    function fill(t, m) { return String(t || '').replace(/\{(\w+)\}/g, function (_, k) { return m[k] != null ? m[k] : ''; }); }
    function setText(sel, txt) { var el = sec.querySelector(sel); if (el) el.textContent = txt; }

    function checkFree() {
      var prices = cards.map(function (c) { return +c.getAttribute('data-price'); }).sort(function (a, b) { return a - b; });
      var low = 0; for (var i = 0; i < freeN && i < prices.length; i++) low += prices[i];
      if (!freeCents || !freeN || prices.length < freeN || low * (1 - pct(freeN) / 100) < freeCents) {
        freeN = 0; [].forEach.call(sec.querySelectorAll('[data-byo-free]'), function (el) { el.remove(); });
        [].forEach.call(sec.querySelectorAll('[data-byo-nofree]'), function (el) { el.hidden = false; });
      }
    }

    function read() {
      return fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var q = {}, n = 0, lines = [], real = {}, ours = 0, other = 0, pre = C.title || 'Your set';
          (cart.items || []).forEach(function (l) {
            var id = String(l.variant_id);
            if (!elig[id] || l.selling_plan_allocation) return;
            q[id] = (q[id] || 0) + l.quantity; n += l.quantity; lines.push(l);
            var r = real[id] || (real[id] = { q: 0, orig: 0, fin: 0 });
            r.q += l.quantity; r.orig += l.original_line_price; r.fin += l.final_line_price;
            (l.line_level_discount_allocations || []).forEach(function (a) {
              var tt = (a.discount_application && a.discount_application.title) || '';
              if (tt.indexOf(pre) === 0) ours += a.amount; else other += a.amount;
            });
          });
          // a customer's code (e.g. ONEOFUS) can replace the set discount when it saves more (Shopify keeps the
          // bigger one; they never stack on a bottle). Then the page shows the code's real numbers, not the tier.
          var code = ((cart.discount_codes || []).filter(function (d) { return d.applicable; })[0] || {}).code || '';
          state = { qty: q, n: n, lines: lines, full: 0, real: real, ours: ours, other: other, codeOn: other > 0 && !ours, code: code };
          render();
        }).catch(function () {});
    }

    function render() {
      var n = state.n, p = pct(n), nx = next(n);
      [].forEach.call(sec.querySelectorAll('[data-byo-tier]'), function (el) {
        var t = +el.getAttribute('data-byo-tier'), last = el.hasAttribute('data-byo-last');
        var on = n > 0 && (last ? n >= t : n === t);
        el.classList.toggle('is-on', on);
        el.classList.toggle('is-next', !!nx && nx[0] === t && !on);
      });
      var full = 0, saved = 0;
      cards.forEach(function (c) {
        var vid = c.getAttribute('data-vid'), q = state.qty[vid] || 0, price = +c.getAttribute('data-price');
        var add = c.querySelector('[data-byo-add]'), step = c.querySelector('[data-byo-step]');
        if (add) add.hidden = q > 0;
        if (step) { step.hidden = q === 0; var qq = step.querySelector('[data-byo-qty]'); if (qq) qq.textContent = fill(C.txt.inSet, { n: q }); }
        // per bottle: Shopify's own line numbers when it discounted the line (set or code), else the tier math
        var rl = state.real && state.real[vid], rOff = rl && rl.q ? Math.round((rl.orig - rl.fin) / rl.q) : 0;
        var unitOff = rOff > 0 ? rOff : (state.codeOn ? 0 : off1(price, p)), disc = !!(q && unitOff > 0);
        var now = c.querySelector('[data-byo-pnow]'), was = c.querySelector('[data-byo-pwas]'), sv = c.querySelector('[data-byo-psave]');
        if (now) { now.textContent = money(disc ? price - unitOff : price); now.classList.toggle('is-disc', disc); }
        if (was) { was.textContent = money(price); was.hidden = !disc; }
        if (sv) { sv.textContent = disc ? fill(C.txt.save, { amt: money(unitOff) }) : ''; sv.hidden = !disc; }
        full += q * price;
        saved += q * off1(price, p); // per bottle, rounded down like Shopify
      });
      state.full = full; state.saved = state.codeOn ? state.other : (state.ours || saved);
      if (toastEl && !toastEl.hidden) fillToast();
    }
    function nextLine(n) {
      var nx = next(n); if (!nx) return fill(C.txt.best, { p: pct(n) });
      // "and free shipping" only when the set doesn't already ship free (2 dearer bottles can clear the line)
      var freeNow = freeCents && state.full - (state.saved || 0) >= freeCents;
      var k = nx[0] - n, free = !freeNow && freeN && nx[0] >= freeN && n < freeN;
      return fill(free ? C.txt.nextFree : C.txt.next, { k: k, p: nx[1] });
    }
    function fillToast() {
      var n = state.n, p = pct(n), full = state.full, saved = state.saved || 0;
      if (!n) { hideToast(); return; }
      var free = freeCents && full - saved >= freeCents;
      if (state.codeOn) {
        // the customer's code saves more than the set right now: say so, and show the first tier that would beat it
        var cp = full ? saved * 100 / full : 0, beat = null;
        for (var i = 0; i < C.tiers.length; i++) if (C.tiers[i][0] > n && C.tiers[i][1] > cp + 0.05) { beat = C.tiers[i]; break; }
        setText('[data-byo-t1]', C.txt.codeHead);
        setText('[data-byo-tsave]', fill(C.txt.codeLine, { code: state.code || C.txt.yourCode, amt: money(saved) }) + (free ? ' · ' + C.txt.free : '') + '.');
        setText('[data-byo-t2]', beat ? fill(C.txt.codeNext, { k: beat[0] - n, p: beat[1] }) : '');
        place();
        return;
      }
      // 2+ bottles (Amir Oct 20): "You built your own set!" then "2 bottles · 3% off · you save $3.13", the same words as the cart drawer card
      setText('[data-byo-t1]', n >= 2 ? C.txt.built : fill(C.txt.trayOne, { n: n }));
      setText('[data-byo-tsave]', p ? fill(C.txt.line, { n: n, p: p, amt: money(saved) }) + (free ? ' · ' + C.txt.free : '') + '.' : '');
      setText('[data-byo-t2]', nextLine(n));
      place();
    }
    // The helper floats from the card that was just added (Amir Oct 20: "a floating toaster when they click
    // the CTA ... so they also feel it interacting with them"). position:fixed, placed below the card's
    // button (above it when there is no room), arrow on the button, kept in place on page and row scroll;
    // it steps out of sight while its card is scrolled out of the row.
    var anchorCard = null, raf = 0;
    function place() {
      if (!toastEl || toastEl.hidden || !anchorCard) return;
      var a = anchorCard.querySelector('[data-byo-step]:not([hidden])') || anchorCard.querySelector('[data-byo-add]') || anchorCard;
      var r = a.getBoundingClientRect(), vw = document.documentElement.clientWidth;
      var track = anchorCard.closest('[data-h26s-track]'), tr = track ? track.getBoundingClientRect() : null;
      var cx = r.left + r.width / 2;
      toastEl.classList.toggle('is-off', !!(tr && (cx < tr.left || cx > tr.right)));
      var w = toastEl.offsetWidth, h = toastEl.offsetHeight;
      var left = Math.max(16, Math.min(vw - w - 16, cx - w / 2));
      // below the button when it fits (the card's price stays in view), else above; 90px kept for the page's bottom bar
      var vh = window.innerHeight, below = r.bottom + 14 + h <= vh - 90 || r.top - h - 14 < 84;
      var top = below ? r.bottom + 14 : r.top - h - 14;
      toastEl.style.left = Math.round(left) + 'px'; toastEl.style.top = Math.round(top) + 'px';
      toastEl.style.setProperty('--arw', Math.round(Math.max(20, Math.min(w - 20, cx - left))) + 'px');
      toastEl.classList.toggle('is-below', below);
    }
    function schedule() { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; place(); }); }
    function showToast(card) {
      if (!toastEl || !state.n) return;
      anchorCard = card || anchorCard || cards[0];
      var again = !toastEl.hidden;
      toastEl.hidden = false; toastEl.classList.remove('is-show');
      fillToast();
      // restart the pop when it moves to another card; a quick ring on the card's stepper says "added"
      void toastEl.offsetWidth;
      requestAnimationFrame(function () { toastEl.classList.add('is-show'); });
      var step = anchorCard && anchorCard.querySelector('[data-byo-step]');
      if (step) { step.classList.remove('is-added'); void step.offsetWidth; step.classList.add('is-added'); }
      if (!again) track('byo_toast_view', { bottles: state.n, tier: pct(state.n) });
    }
    function hideToast() {
      if (!toastEl || toastEl.hidden) return;
      toastEl.classList.remove('is-show');
      setTimeout(function () { if (!toastEl.classList.contains('is-show')) toastEl.hidden = true; }, 200);
    }
    function openCart() {
      hideToast(); track('byo_view_cart', { bottles: state.n });
      try { var r = window.upcartRefreshCart && window.upcartRefreshCart(); Promise.resolve(r).then(function () { if (window.upcartOpenCart) window.upcartOpenCart(); else location.href = '/cart'; }); }
      catch (e) { location.href = '/cart'; }
    }
    // "Add more": close the helper, slide the row to the next bottle not in the cart (after the one just
    // added, wrapping round), and pulse its Add to cart
    function addMore() {
      hideToast(); track('byo_add_more', { bottles: state.n });
      var i = cards.indexOf(anchorCard), pick = null;
      for (var j = 1; j <= cards.length && !pick; j++) {
        var c = cards[(Math.max(i, 0) + j) % cards.length];
        if (!(state.qty[c.getAttribute('data-vid')] > 0)) pick = c;
      }
      if (!pick) return;
      var tk = pick.closest('[data-h26s-track]'), smooth = !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
      if (tk) {
        var tr = tk.getBoundingClientRect(), pr = pick.getBoundingClientRect();
        if (pr.left < tr.left || pr.right > tr.right) tk.scrollTo({ left: tk.scrollLeft + pr.left - tr.left, behavior: smooth ? 'smooth' : 'auto' });
      }
      var btn = pick.querySelector('[data-byo-add]');
      if (btn) { btn.classList.remove('is-nudge'); void btn.offsetWidth; btn.classList.add('is-nudge'); setTimeout(function () { btn.classList.remove('is-nudge'); }, 1600); }
    }
    function refreshDrawer() { try { window.upcartRefreshCart && window.upcartRefreshCart(); } catch (e) {} }

    function addOne(card) {
      var f = card.querySelector('form[data-h26-atc]'); if (!f) return;
      if (f.requestSubmit) f.requestSubmit(); else if (window.OOH26 && window.OOH26.addToCart) window.OOH26.addToCart(f);
    }
    function removeOne(card) {
      var vid = card.getAttribute('data-vid');
      var line = state.lines.filter(function (l) { return String(l.variant_id) === vid; })[0];
      if (!line) return;
      card.setAttribute('aria-busy', 'true');
      fetch('/cart/change.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: Math.max(0, line.quantity - 1) }) })
        .then(function () { track('byo_remove', { variant_id: +vid }); refreshDrawer(); return read(); })
        .then(function () { card.removeAttribute('aria-busy'); }, function () { card.removeAttribute('aria-busy'); });
    }

    sec.addEventListener('click', function (e) {
      var c = e.target.closest('[data-byo-card]');
      // "Add to cart" is the card form's own submit button (h26-atc handles it); '+' on the stepper submits the same form
      if (e.target.closest('[data-byo-plus]') && c) { e.preventDefault(); addOne(c); return; }
      if (e.target.closest('[data-byo-minus]') && c) { e.preventDefault(); removeOne(c); return; }
      if (e.target.closest('[data-byo-close]')) { hideToast(); track('byo_toast_close', { bottles: state.n }); return; }
      if (e.target.closest('[data-byo-view]')) { e.preventDefault(); openCart(); return; }
      if (e.target.closest('[data-byo-more]')) { e.preventDefault(); addMore(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && toastEl && !toastEl.hidden) hideToast(); });
    // a tap anywhere else closes it, like any popover
    document.addEventListener('click', function (e) {
      if (!toastEl || toastEl.hidden || toastEl.contains(e.target) || e.target.closest('[data-byo-card]')) return;
      hideToast();
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    [].forEach.call(sec.querySelectorAll('[data-h26s-track]'), function (tk) { tk.addEventListener('scroll', schedule, { passive: true }); });
    // our forms report through h26-atc's bubbling event
    sec.addEventListener('h26:atc', function (e) {
      var d = e.detail || {};
      if (!e.target.closest('[data-byo-card]')) return;
      var card = e.target.closest('[data-byo-card]');
      read().then(function () { if (d.outcome === 'success') showToast(card); });
    });
    // the drawer changed the cart (remove, quantity): stay in step
    ['cart-updated', 'item-removed'].forEach(function (k) {
      window.addEventListener('aftersell-upcart:public-events:' + k, function () { setTimeout(read, 150); });
    });
    var thr = (!freeCents && sec.hasAttribute('data-h26-thr-src') && window.H26Thr) ? window.H26Thr.resolve(sec) : null;
    Promise.resolve(thr).then(function (r) { if (r && r.cents) freeCents = r.cents; }, function () {}).then(function () { checkFree(); read(); });
  }
  function init() { [].forEach.call(document.querySelectorAll('[data-h26-byo]'), boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
